/* eslint-disable */
import { CR, RC, AJRS } from './base_i2_success_codes'
import bi1_data_validation from './base_i1_datavalidation'
import base_i3_log from './base_i3_logging'
import writeCICPGui from './json_tasks/p1s6/p1s6t6'
import Vue from 'vue'
import moment from 'moment';
import localForage from 'localforage';
import c11SupportedGraphicalElements from "./c11SupportedGraphicalElements";
import default_watchdog_layout from "./default_watchdog_layout";
import sample_NEU_GUI_Data from "./sample_NEU_GUI_Data";
import sample_Crestron_GUI_Layout from "./sample_Crestron_GUI_Layout";
import sample_Valley_GUI_Layout from "./sample_Valley_GUI_Layout";
import getUserOrgsCpsCicps from './json_tasks/p1s6/p1s6t7';
import getUserPermission from './json_tasks/p1s6/p1s6t9'

// CI == class instance
// IV == instance variable
"use strict";
class bi7WebGuiData {
  constructor() {
    var CI = this;
    CI.IV_local_forage = localForage;
    CI.IV_local_forage.config({
      driver: [
        CI.IV_local_forage.INDEXEDDB,
        CI.IV_local_forage.LOCALSTORAGE,
        CI.IV_local_forage.WEBSQL
      ],
      name: 'DGnet_Web_GUI'
    });
    CI.IV_firebase_db_object = null;
    CI.IV_firestore_db_object = null;
    CI.IV_id_token_pointer = '';
    CI.IV_firebase_uid_pointer = '';
    CI.IV_firebase_guest_flag_pointer = true;
    CI.IV_firebase_email_pointer = '';
    CI.IV_instance_initialized = false;
    CI.IV_user_folder_firestore_path_ref = ''

    CI.IV_data_change_callbacks = {'IV_user_info': null};
    CI.IV_listener_user_info = {};
    
    CI.IV_user_info = { 'uid': 0, 'contact_email': '', 'first_name': '', 'last_name': '' };
    CI.IV_user_organization_data = {};
    CI.IV_user_organization_data_ready = false;
    CI.IV_success_global_callbacks = {};
    CI.IV_failure_global_callbacks = {};

    CI.IV_processor_last_connect_time = {}
    CI.IV_processor_last_disconnect_time = {}
    CI.IV_processor_last_checkin_time = {}

    CI.IV_listeners_processor_last_connect_time = {}
    CI.IV_listeners_processor_last_disconnect_time = {}
    CI.IV_listeners_processor_last_checkin_time = {}

    // web gui data structures
    CI.IV_org_metadata = {};
    CI.IV_control_processors_metadata = {};
    CI.IV_available_graphical_elements = c11SupportedGraphicalElements;
    

    // TODO- make proper fix for this. May be a flag from backend?
    CI.IV_is_neu_room_panel = true
    CI.IV_is_crestron_device = false;
    CI.IV_is_valley_device = false

    CI.IV_sample_layout_information_data = default_watchdog_layout['layout_information'];
    CI.IV_sample_layout_elements_data = default_watchdog_layout['layout_elements'];  
  }

  bi7SetFirebaseToken(firebase_token=null) {
    var debug_data = [];
    var call_result = {};
    var return_msg = "bi7WebGuiData:bi7SetFirebaseToken ";
    var task_id = "bi7WebGuiData:bi7SetFirebaseToken";

    ////// input validation
    call_result = bi1_data_validation.is_string(firebase_token);
    debug_data.push(call_result);

    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
    }
    //////</end> input validation

    var CI = this;
    CI.IV_id_token_pointer = firebase_token;
  }
  
  setFirebaseParams(firebase_db_object = null, firebase_token = '', firebase_uid = '',firebae_email = '',guest_flag=true) {
    var debug_data = [];
    var call_result = {};
    var return_msg = "bi7WebGuiData:setFirebaseParams ";
    var task_id = "bi7WebGuiData:setFirebaseParams";

    ////// input validation
    try {
      call_result = bi1_data_validation.is_string(firebase_db_object['app']['options_']['apiKey']);
      debug_data.push(call_result);
    } catch (err) {
      return_msg += "fire_base_db_object is not valid, errors:" + JSON.stringify(err.message);
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }

    call_result = bi1_data_validation.is_string(firebase_token);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(firebase_uid);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_email_address(firebae_email);
    debug_data.push(call_result);


    var validation_failed = false;
    for (var index in debug_data) {
      if (debug_data[index][CR.success] !== RC.success) {
        validation_failed = true;
      }
    }

    if(validation_failed === true) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    //////</end> input validation
    var CI = this;
    CI.IV_id_token_pointer = firebase_token;
    CI.IV_firebase_uid_pointer = firebase_uid;
    CI.IV_firebase_email_pointer = firebae_email;
    CI.IV_firebase_guest_flag_pointer = guest_flag;
    CI.IV_firebase_db_object = firebase_db_object;
    CI.IV_firestore_db_object = window.firebase.apps[1].firestore();

    if (guest_flag === true) {
      CI.IV_user_folder_firestore_path_ref = CI.IV_firestore_db_object.collection('FsP1UserInformation').doc('guest');
    } else {
      CI.IV_user_folder_firestore_path_ref = CI.IV_firestore_db_object.collection('FsP1UserInformation').doc(CI.IV_firebase_uid_pointer);
    }

    CI.IV_instance_initialized = true;
  }

  callCallBackFunction(callback, args = null) {
    var call_result = {};
    var debug_data = [];
    var return_msg = "bi7WebGuiData:callCallBackFunction";
    var task_id = "bi7WebGuiData:callCallBackFunction";

    ////// input validation
    call_result = bi1_data_validation.is_function(callback)
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
    }
    //////</end> input validation

    try {
      if (Array.isArray(args) === true) {
        callback(args)
      } else {
        callback([args])
      }
    } catch (err) {
      return_msg += "callback execution failed with error:" + JSON.stringify(err);
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
  }

  setSuccessGlobalCallBack(function_name = '', callback = null) {
    var debug_data = [];
    var call_result = {};
    var return_msg = "bi7WebGuiData:setSuccessCallBack ";
    var task_id = "bi7WebGuiData:setSuccessCallBack";
    var CI = this;

    ///// input validation
    call_result = bi1_data_validation.is_function(callback);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    
    call_result = bi1_data_validation.is_string(function_name);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    /////</end> input validation

    CI.IV_success_global_callbacks[function_name] = callback;
    return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
  }

  setFailureGlobalCallBack(function_name = '', callback = null) {
    var debug_data = [];
    var call_result = {};
    var return_msg = "bi7WebGuiData:setFailureCallBack ";
    var task_id = "bi7WebGuiData:setFailureCallBack";
    var CI = this;
    
    ///// input validation
    call_result = bi1_data_validation.is_function(callback);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    
    call_result = bi1_data_validation.is_string(function_name);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    /////</end> input validation

    CI.IV_failure_global_callbacks[function_name] = callback;
    return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
  }

  bi7setDataChangedCallback(instance_variable, callback) {
    var debug_data = [];
    var call_result = {};
    var return_msg = "bi7WebGuiData:bi7setDataChangedCallback ";
    var task_id = "bi7WebGuiData:bi7setDataChangedCallback";
    var CI = this;

    call_result = bi1_data_validation.is_string(instance_variable);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_function(callback);
    debug_data.push(call_result);
    var validation_failed = false;
    for (var index in debug_data) {
      if (debug_data[index][CR.success] !== RC.success) {
        validation_failed = true;
      }
    }

    if(validation_failed === false && instance_variable in CI.IV_data_change_callbacks === false) {
      return_msg+= 'attempt to set a callback for an instance variable that is not the data change callbacks'
      validation_failed = true;
    }

    if(validation_failed === true) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }

    CI.IV_data_change_callbacks[instance_variable] = callback;
    return { success: RC.success, return_msg: return_msg, debug_data: debug_data };   
  }

  InitUserInfoListener() {
    const CI = this;
    const debug_data = [];
    let return_msg = 'bi7WebGuiData:InitUserInfoListener ';
    const task_id = 'bi7WebGuiData:InitUserInfoListener';

    if (CI.IV_instance_initialized === false) {
      return_msg += 'instance is not initialized';
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    CI.IV_listener_user_info = CI.IV_user_folder_firestore_path_ref.onSnapshot(
      doc => CI.UserInfoListener(doc),
      errorObject => {
        return_msg += 'firestore read failed with error data:' + errorObject;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
      }
    );

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  UserInfoListener(doc) {
    const CI = this;
    const debug_data = [];
    let return_msg = 'bi7WebGuiData:UserInfoListener ';
    const task_id = 'bi7WebGuiData:UserInfoListener';

    ////// input validation
    if (doc === null || !doc.data()) {
      return_msg += 'doc argument is null or there was no data in the document';
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
    }
    //////</end> input validation 

    const firebase_data = doc.data();
    const keys = Object.keys(CI.IV_user_info)
    
    for (let index in keys) {
      const key = keys[index];
      CI.IV_user_info[key] = firebase_data[key];
    }

    CI.IV_user_info['uid'] = firebase_data['user_uid'] ? firebase_data['user_uid'].toString() : "";
    
    if (CI.IV_firebase_guest_flag_pointer === true) {
      CI.IV_user_info['firebase_uid'] = CI.IV_firebase_uid_pointer;
    }
    
    CI.callCallBackFunction(CI.IV_data_change_callbacks['IV_user_info']);

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  bi7GetUserOrganizationData() {
    const debug_data = [];
    let return_msg = 'bi7WebGuiData:bi7GetUserOrganizationData ';
    const task_id = "bi7WebGuiData:bi7GetUserOrganizationData";
    const CI = this;

    const user_uid = CI.IV_user_info["uid"];
    const firebase_email = CI.IV_firebase_email_pointer;
    const firebase_token = CI.IV_id_token_pointer;
    let call_failed = false;

    getUserOrgsCpsCicps(
      user_uid, 
      firebase_email, 
      firebase_token
    ).then(response => {
      CI.bi7SetUserOrganizationData(JSON.parse(response['json_response']))
      debug_data.push(response);
      CI.IV_user_organization_data_ready = true;
    }).catch(err => {
      call_failed = true;
      return_msg += ' ajax call to p1s6t7 failed';
      debug_data.push(err);
      CI.IV_user_organization_data_ready = true;
    });

    return { 'success':  call_failed ? RC.ajax_failure : RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  bi7GetUserPermissionData(org_uid, cicp_uid) {
    const CI = this
    const debug_data = []
    const task_id = 'bi7WebGuiData:bi7GetUserPermissionData'
    let return_msg = 'bi7WebGuiData:bi7GetUserPermissionData '

    ////// input validation
    let call_result = bi1_data_validation.is_string(org_uid)
    debug_data.push(call_result)
    call_result = bi1_data_validation.is_string(cicp_uid)
    debug_data.push(call_result)

    let validation_failed = false
    for (let index in debug_data) {
      if (debug_data[index][CR.success] !== RC.success) {
        validation_failed = true
      }
    }
    if (validation_failed === true) {
      return_msg += 'input validation failed'
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data)
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data }
    }
    //////</end> input validation

    let call_failed = false;

    getUserPermission(
      CI.IV_user_info['uid'],
      CI.IV_firebase_email_pointer,
      CI.IV_id_token_pointer,
      org_uid,
      cicp_uid,
      window.G_firebase_auth.IV_is_guest
    ).then(response => {
      CI.bi7SetUserPermissionData(JSON.parse(response['json_response']), org_uid, cicp_uid)
      debug_data.push(response);
      CI.IV_user_organization_data_ready = true;
    }).catch(err => {
      call_failed = true;
      return_msg += ' ajax call to p1s6t9 failed';
      debug_data.push(err);
      CI.IV_user_organization_data_ready = true;
    });

    return { 'success':  call_failed ? RC.ajax_failure : RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  bi7SetUserPermissionData(data, org_id, cicp_id){
    const debug_data = []
    const task_id = 'bi7WebGuiData:bi7GetUserPermissionData'
    let return_msg = 'bi7WebGuiData:bi7GetUserPermissionData '
    let call_result = {};
    const CI = this;
    
    /// input validation
    call_result = bi1_data_validation.is_string(org_id);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(cicp_id);
    debug_data.push(call_result);

    var validation_failed = false;
    for (var index in debug_data) {
      if (debug_data[index][CR.success] !== RC.success) {
        validation_failed = true;
      }
    }

    if (validation_failed === true) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    
    if (data === undefined || data === null) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
    }
    ///</end> input validation
   
    const org_uid = `org_${org_id}`;
    const cicp_uid = `cicp_${cicp_id}`
    const cp_uid = `cp_${data["cp_uid"]}`
    
    if (org_uid in CI.IV_user_organization_data === false) {
      Vue.set(CI.IV_user_organization_data, org_uid, {});
    }

    if (cp_uid in CI.IV_user_organization_data[org_uid] === false) {
      Vue.set(CI.IV_user_organization_data[org_uid], cp_uid, {});
    }
    
    if (org_uid in CI.IV_org_metadata === false) {
      Vue.set(CI.IV_org_metadata, org_uid, {});
    }

    if (cp_uid in CI.IV_control_processors_metadata === false) {
      Vue.set(CI.IV_control_processors_metadata, cp_uid, {})
    }

    /// setting org_name  in IV_org_metadata
    if (data["org_name"] !== null && data["org_name"] !== undefined ) {
      Vue.set(CI.IV_org_metadata[org_uid], "name", data["org_name"]);
    }
    ///</end> setting org_name  in IV_org_metadata

    /// setting permissions for IV_org_metadata
    if (data["permissions"] !== null && data["permissions"] !== undefined) {
      let permissions = data["permissions"] === "ONLY READ" ? "" : data["permissions"];
      Vue.set(CI.IV_org_metadata[org_uid], "permissions", permissions);
    }
    ///</end> setting permissions for IV_org_metadata
  
    /// setting  cp_name in IV_control_processors_metadata
    if (data["cp_name"] !== null && data["cp_name"] !== undefined) {
      Vue.set(CI.IV_control_processors_metadata[cp_uid], "name", data["cp_name"]);
    }

    if (cicp_uid in CI.IV_user_organization_data[org_uid][cp_uid] === false) {
      Vue.set(CI.IV_user_organization_data[org_uid][cp_uid], "cicps", {});
    }
    Vue.set(CI.IV_user_organization_data[org_uid][cp_uid]["cicps"], cicp_uid, cicp_uid);
    /// </end> setting  cp_name in IV_control_processors_metadata

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  bi7SetUserOrganizationData(data) {
    const debug_data = [];
    let return_msg = 'bi7WebGuiData:bi7SetUserOrganizationData ';
    let task_id = "bi7WebGuiData:bi7SetUserOrganizationData";
    const CI = this;

    /// input validation
    if (data === undefined || data === null) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
    }
    /// </end> input validation

    for (let org_key in data) {
      let org_uid = `org_${org_key}`;

      if (org_uid in CI.IV_user_organization_data === false) {
        Vue.set(CI.IV_user_organization_data, org_uid, {});
      }
      for (let cp_key in data[org_key]) {

        /// Setting user's org permissions to IV_org_metadata
        if (cp_key === "permissions") {
          if (org_uid in CI.IV_org_metadata === false) {
            Vue.set(CI.IV_org_metadata, org_uid, {});
          }
          Vue.set(CI.IV_org_metadata[org_uid], "permissions", data[org_key][cp_key]);
          continue;
        }
        /// Setting user's org permissions to IV_org_metadata

        /// Setting org name to IV_org_metadata
        if (cp_key === "org_name") {
          if (org_uid in CI.IV_org_metadata === false) {
            Vue.set(CI.IV_org_metadata, org_uid, {});
          }

          Vue.set(CI.IV_org_metadata[org_uid], "name", data[org_key][cp_key]);
          continue;
        }
        ///</end> Setting org name to IV_org_metadata

        const cp_uid = `cp_${cp_key}`;
        const cp_data = data[org_key][cp_key];

        if (cp_uid in CI.IV_user_organization_data[org_uid] === false) {
          Vue.set(CI.IV_user_organization_data[org_uid], cp_uid, {});
        }
        
        if ("cp_name" in cp_data === true) {
          if (cp_uid in CI.IV_control_processors_metadata === false) {
            Vue.set(CI.IV_control_processors_metadata, cp_uid, {})
          }
          Vue.set(CI.IV_control_processors_metadata[cp_uid], "name", cp_data["cp_name"]);
        }

        if ("cicps" in cp_data === true) {
          Vue.set(CI.IV_user_organization_data[org_uid][cp_uid], "cicps", {});

          for (let cicp_key in cp_data["cicps"]) {
            const cicp_uid = `cicp_${cicp_key}`;
            const interface_type = cp_data["cicps"][cicp_key];

            Vue.set(CI.IV_user_organization_data[org_uid][cp_uid]["cicps"], cicp_uid, interface_type);
          }
        }
      }
    }

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  bi7SaveCicpGuiData(org_uid, cp_uid, cicp_uid, layout_information, layout_elements) {
    const CI = this
    const debug_data = []
    const task_id = 'bi7WebGuiData:bi7SaveCicpGuiData'
    let return_msg = 'bi7WebGuiData:bi7SaveCicpGuiData '

    ////// input validation
    let call_result = bi1_data_validation.is_string(org_uid)
    debug_data.push(call_result)
    call_result = bi1_data_validation.is_string(cp_uid)
    debug_data.push(call_result)
    call_result = bi1_data_validation.is_string(cicp_uid)
    debug_data.push(call_result)
    call_result = bi1_data_validation.is_not_null(layout_information)
    debug_data.push(call_result)
    call_result = bi1_data_validation.is_not_null(layout_elements)
    debug_data.push(call_result)

    let validation_failed = false
    for (let index in debug_data) {
      if (debug_data[index][CR.success] !== RC.success) {
        validation_failed = true
      }
    }
    if (validation_failed === true) {
      return_msg += 'input validation failed'
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data)
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data }
    }
    //////</end> input validation

    let response = writeCICPGui(
      CI.IV_user_info['uid'],
      CI.IV_firebase_email_pointer,
      CI.IV_id_token_pointer,
      cp_uid,
      org_uid,
      cicp_uid,
      layout_information,
      layout_elements
    )

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data, response_promise: response };
  }

  initSystemOnlineListeners(cp_uid) {
    const debug_data = []
    const task_id = 'bi7WebGuiData:initSystemOnlineListeners'
    let return_msg = 'bi7WebGuiData:initSystemOnlineListeners '
    let call_result = {};
    const CI = this;

    ///// input validation
    call_result = bi1_data_validation.is_string(cp_uid);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    /////</end> input validation

    if (cp_uid in CI.IV_processor_last_connect_time === false)
      Vue.set(CI.IV_processor_last_connect_time, cp_uid, {})

    if (cp_uid in CI.IV_processor_last_disconnect_time === false)
      Vue.set(CI.IV_processor_last_disconnect_time, cp_uid, {})

    if (cp_uid in CI.IV_processor_last_checkin_time === false)
      Vue.set(CI.IV_processor_last_checkin_time, cp_uid, {})

    CI.initLastProcessorConnectTimeListener(cp_uid);
    CI.initLastProcessorDisConnectTimeListener(cp_uid);
    CI.initLastProcessorCheckInListener(cp_uid);

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  stopSystemOnlineListeners(cp_uid) {
    const debug_data = []
    const task_id = 'bi7WebGuiData:stopSystemOnlineListeners'
    let return_msg = 'bi7WebGuiData:stopSystemOnlineListeners '
    let call_result = {};
    const CI = this;

    ///// input validation
    call_result = bi1_data_validation.is_string(cp_uid);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    /////</end> input validation

    // TODO- Check and stop all listeners mentioned below
    // CI.IV_processor_last_connect_time[cp_uid]
    // CI.IV_processor_last_disconnect_time[cp_uid]
    // CI.IV_processor_last_checkin_time[cp_uid]
  }

  initLastProcessorConnectTimeListener(cp_uid) {
    const debug_data = []
    const task_id = 'bi7WebGuiData:initLastProcessorConnectTimeListener'
    let return_msg = 'bi7WebGuiData:initLastProcessorConnectTimeListener '
    let call_result = {};
    const CI = this;

    ///// input validation
    call_result = bi1_data_validation.is_string(cp_uid);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    /////</end> input validation

    // We already have a listener for this cp
    if (cp_uid in CI.IV_listeners_processor_last_connect_time === true) { return; }

    const listenerRef = CI.IV_firestore_db_object.collection('FsP1Lastp1s3ConnectTime').doc(cp_uid.replace("cp_", "")).onSnapshot(
      function(a_data) {CI.lastProcessorConnectTimeListenerCallback(cp_uid, a_data)}.bind(CI),
      function (errorObject) {
        return_msg += 'firestore read failed with error data:' + errorObject;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
      }.bind(CI)
    );

    CI.IV_listeners_processor_last_connect_time[cp_uid] = listenerRef;

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  lastProcessorConnectTimeListenerCallback(cp_uid, doc) {
    const debug_data = []
    const task_id = 'bi7WebGuiData:lastProcessorConnectTimeListenerCallback'
    let return_msg = 'bi7WebGuiData:lastProcessorConnectTimeListenerCallback '
    let call_result = {};
    const CI = this;

    ///// input validation
    call_result = bi1_data_validation.is_string(cp_uid);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }

    if (doc === null || !doc.data()) {
      return_msg += 'doc argument is null';
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
    }
    /////</end> input validation

    const firestore_data = doc.data();
    if ('last_connect_time' in firestore_data === false) {return}

    Vue.set(CI.IV_processor_last_connect_time[cp_uid], 'last_connect_time', firestore_data['last_connect_time'])

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  initLastProcessorDisConnectTimeListener(cp_uid) {
    const debug_data = []
    const task_id = 'bi7WebGuiData:initLastProcessorDisConnectTimeListener'
    let return_msg = 'bi7WebGuiData:initLastProcessorDisConnectTimeListener '
    let call_result = {};
    const CI = this;

    ///// input validation
    call_result = bi1_data_validation.is_string(cp_uid);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    /////</end> input validation

    // We already have a listener for this cp
    if (cp_uid in CI.IV_listeners_processor_last_disconnect_time === true) { return; }

    const listenerRef = CI.IV_firestore_db_object.collection('FsP1Lastp1s3DisconnectTime').doc(cp_uid.replace("cp_", "")).onSnapshot(
      function(a_data) {CI.lastProcessorDisConnectTimeListenerCallback(cp_uid, a_data)}.bind(CI),
      function (errorObject) {
        return_msg += 'firestore read failed with error data:' + errorObject;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
      }.bind(CI)
    );

    CI.IV_listeners_processor_last_disconnect_time[cp_uid] = listenerRef;

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  lastProcessorDisConnectTimeListenerCallback(cp_uid, doc) {
    const debug_data = []
    const task_id = 'bi7WebGuiData:lastProcessorDisConnectTimeListenerCallback'
    let return_msg = 'bi7WebGuiData:lastProcessorDisConnectTimeListenerCallback '
    let call_result = {};
    const CI = this;

    ///// input validation
    call_result = bi1_data_validation.is_string(cp_uid);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }

    if (doc === null || !doc.data()) {
      return_msg += 'doc argument is null';
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
    }


    const firestore_data = doc.data();
    if ('last_disconnect_time' in firestore_data === false) {return}

    Vue.set(CI.IV_processor_last_disconnect_time[cp_uid], 'last_disconnect_time', firestore_data['last_disconnect_time'])

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  initLastProcessorCheckInListener(cp_uid) {
    const debug_data = []
    const task_id = 'bi7WebGuiData:initLastProcessorCheckInListener'
    let return_msg = 'bi7WebGuiData:initLastProcessorCheckInListener '
    let call_result = {};
    const CI = this;

    ///// input validation
    call_result = bi1_data_validation.is_string(cp_uid);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    /////</end> input validation

    // We already have a listener for this cp
    if (cp_uid in CI.IV_listeners_processor_last_checkin_time === true) { return; }

    const listenerRef = CI.IV_firestore_db_object.collection('FsP1LastProcessorCheckIn').doc(cp_uid.replace("cp_", "")).onSnapshot(
      function(a_data) {CI.lastProcessorCheckinListenerCallback(cp_uid, a_data)}.bind(CI),
      function (errorObject) {
        return_msg += 'firestore read failed with error data:' + errorObject;
        base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
      }.bind(CI)
    );

    CI.IV_listeners_processor_last_checkin_time[cp_uid] = listenerRef;

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  lastProcessorCheckinListenerCallback(cp_uid, doc) {
    const debug_data = []
    const task_id = 'bi7WebGuiData:lastProcessorCheckinListenerCallback'
    let return_msg = 'bi7WebGuiData:lastProcessorCheckinListenerCallback '
    let call_result = {};
    const CI = this;

    ///// input validation
    call_result = bi1_data_validation.is_string(cp_uid);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }

    if (doc === null || !doc.data()) {
      return_msg += 'doc argument is null';
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
    }


    const firestore_data = doc.data();
    if ('last_check_in' in firestore_data === false) {return}

    Vue.set(CI.IV_processor_last_checkin_time[cp_uid], 'last_check_in', firestore_data['last_check_in'])

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

}

export default bi7WebGuiData



// WEBPACK FOOTER //
// ./src/watchdog_includes/base_i7_web_gui_data.js